import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { apiFetch } from '../api';
import { Input, Btn, Spinner } from '../components';
import PasswordInput from '../components/PasswordInput';
import { AuthShell, AuthStatus } from '../components/AuthForm';

export default function LoginPage({ onLogin, notice = '' }) {
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [pass, setPass] = useState('');
  const [err, setErr] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [recoveryAvailable, setRecoveryAvailable] = useState(null);
  const [capabilityError, setCapabilityError] = useState(false);
  const [cooldown, setCooldown] = useState(0);
  useEffect(() => {
    if (!cooldown) return undefined;
    const timer = setTimeout(() => setCooldown(value => value - 1), 1000);
    return () => clearTimeout(timer);
  }, [cooldown]);
  useEffect(() => {
    let active = true;
    apiFetch('/auth/capabilities').then(data => { if (active) setRecoveryAvailable(data.password_reset_available === true); })
      .catch(() => { if (active) { setCapabilityError(true); setRecoveryAvailable(false); } });
    return () => { active = false; };
  }, []);
  const switchMode = (next) => { setMode(next); setErr(''); setMessage(''); setPass(''); };
  const handle = async (event) => {
    event.preventDefault();
    if (loading) return;
    if (!email || (mode === 'login' && !pass)) return setErr('Preencha e-mail e senha.');
    setLoading(true); setErr(''); setMessage('');
    try {
      if (mode === 'login' && localStorage.getItem('rotaflex_logout_pending')) {
        await apiFetch('/auth/logout', { method: 'POST' });
        localStorage.removeItem('rotaflex_logout_pending');
      }
      const result = await apiFetch(mode === 'login' ? '/auth/login' : '/auth/forgot-password', {
        method: 'POST', body: JSON.stringify(mode === 'login' ? { email, senha: pass } : { email }),
      });
      if (mode === 'login') onLogin();
      else { setMessage(result.mensagem); setCooldown(60); }
    } catch (error) { setErr(error instanceof TypeError ? 'Não foi possível conectar ao RotaFlex. Verifique sua conexão e tente entrar novamente.' : error.message); }
    finally { setLoading(false); }
  };
  if (mode === 'forgot') return <AuthShell title="Recuperar acesso" description="Informe o e-mail da sua conta. O link de recuperação é válido por 30 minutos e só pode ser usado uma vez.">
    {recoveryAvailable === null ? <Spinner /> : recoveryAvailable ? <form onSubmit={handle} style={{ display: 'grid', gap: 16 }}>
      <Input label="E-mail da conta" type="email" autoComplete="email" required disabled={loading} value={email} onChange={e => { setEmail(e.target.value); setErr(''); }} />
      <AuthStatus error={err} message={message} />
      <Btn type="submit" disabled={loading || cooldown > 0} style={{ justifyContent: 'center' }}>{loading ? <><Spinner /> Solicitando…</> : cooldown > 0 ? `Solicitar novamente em ${cooldown}s` : message ? 'Solicitar outro link' : 'Solicitar link de recuperação'}</Btn>
      {message && <p style={{ color: 'var(--muted)', fontSize: '0.9375rem' }}>Confira também a pasta de spam. Se não receber, aguarde um minuto antes de solicitar novamente.</p>}
    </form> : <AuthStatus error={capabilityError ? 'Não foi possível verificar a recuperação de acesso. Tente novamente mais tarde.' : 'A recuperação por e-mail ainda não está disponível. Contate o administrador responsável pelo acesso.'} />}
    <Btn variant="secondary" disabled={loading} onClick={() => switchMode('login')} style={{ marginTop: 16, width: '100%', justifyContent: 'center' }}>Voltar ao login</Btn>
  </AuthShell>;
  return <AuthShell title="Entre na sua conta">
    <form onSubmit={handle} style={{ display: 'grid', gap: 16 }}>
      <Input label="E-mail" type="email" autoComplete="username" inputMode="email" required disabled={loading} value={email} onChange={e => { setEmail(e.target.value); setErr(''); }} />
      <PasswordInput label="Senha" autoComplete="current-password" required disabled={loading} value={pass} onChange={e => { setPass(e.target.value); setErr(''); }} />
      <AuthStatus error={err} message={notice} />
      <Btn type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center' }} size="lg">{loading ? <><Spinner /> Entrando…</> : 'Entrar'}</Btn>
      <Btn variant="secondary" disabled={loading} onClick={() => switchMode('forgot')} style={{ justifyContent: 'center' }}>Esqueci minha senha</Btn>
    </form>
  </AuthShell>;
}
LoginPage.propTypes = { onLogin: PropTypes.func.isRequired, notice: PropTypes.string };
